import {
  memoryrush_logo,
  taxflow_logo,
  potion_Logo,
  pixatopia_logo,
  taxflow_preview,
  potion_preview,
  pixatopia_preview,
  memoryrush_background,
  taxflow_background,
  potion_background,
  pixatopia_background,
  memoryrush_screenshot,
  taxflow_screenshot,
  potion_screenshot,
  pixatopia_screenshot,
  memoryrush_user_details_form,
  taxeflow_infrastructure,
  potion_database_diagram,
  windytheory_logo,
  windytheory_background,
  asyncdococr_logo,
  asyncdococr_background,
  tbench_logo,
  tbench_background,
} from "../imports.js";

export const projectsData = [
  {
    id: 0,
    name: "MemoryRush - Multiplayer Game",
    logo: memoryrush_logo,
    description: "Built with Django, Python, and React, this project showcases real-time communication via WebSockets for a fast, interactive gaming experience.",
    previewImage: memoryrush_logo,
    demo: "https://memoryrush-client.onrender.com/",
    gitRepo: "https://github.com/soulaimanedev/memoryrush.git",
    viewCode: "pointer",
    imgAlt: "memoryrush project logo",
    projectInfoPath: "/project/memoryrush",
    technologies: [
      "Python",
      "Django",
      "React.js",
      "WebSockets",
      "Redis",
      "HTML",
      "CSS"
    ],
    projectDescription: "This project was built to showcase the power of real-time communication using WebSockets. Unlike traditional HTTP requests that require constant refreshing, WebSockets allow for instant, two-way interaction between the client and the server. The goal of this game is not just to entertain, but to demonstrate how modern web applications can provide a smooth, dynamic user experience with live updates. The backend is powered by Python(Django), while the frontend is built with React.js, all working together to create a fast and responsive game environment.",
    functionalities: "Game Overview: MemoryRush is A multiplayer memory card game where players: Join rooms using a room name and password, customize their profile with username and avatar, compete to match pairs from 20 cards, win by being the first to finding all of the matching pairs.",
    modeling: "Features: Real-time gameplay using WebSockets, secure room system with password protection, player customization with avatars. live game state updates. multi-player support.",
    functionalitiesPics: memoryrush_screenshot,
    modelingPics: memoryrush_user_details_form,
    demoVideo: "",
    caseStudyBackground: memoryrush_background,
    backgroundsAttribution: <></>
  },
  {
    id: 1,
    name: "Taxes Platform",
    logo: taxflow_logo,
    description: "An innovative platform meticulously designed to streamline the intricate process of calculating taxes on non-inhabited lands, empowering government commune bureaus to harness technology for optimized fiscal administration.",
    previewImage: taxflow_preview,
    demo: "",
    gitRepo: "https://github.com/soulaimanedev/Tax-Flow-Back-end.git",
    viewCode: "pointer",
    imgAlt: "Taxe-Flow project logo",
    projectInfoPath: "/project/taxe-flow",
    technologies: [
      "UML",
      "MySQL",
      "JAVA",
      "JEE",
      "SpringBoot",
      "Spring JPA",
      "Spring DATA",
      "Spring REST API"
    ],
    projectDescription: "This my bachelor's degree end of year project. A project about creating a plateforme for the local commune centers in Morocco to manage taxes on uninhabited lands.",
    functionalities: "The project's idea was my teacher's, which he then proposed to us the basic functionalities: CRUD operations on a relational database schema. The me and me and my project partner added other functionalities: My Partner's: staff management of the commune, with each one with he's role. Using Spring security to manage staff's routing. I added the ability to create taxes, taxe penalties and exonerations automatically after a staff member enters the details of a land amd it's owner, after that the staff can sit and relax and sip his coffee, while the algorithm calculates taxes, adds penalties each month if the taxe is not payed, and exonerate the land owners that has the right to, and all of this programmed to run 24/7.",
    modeling: "Using Java SpringBoot on the backend has separated the application to multiple layers (beans, data access objects, services, web services) makes the application performing and easy to manage with the sets of technologies that springboot offers, Spring jpa for the beans, Spring data for the data access objects and finally Spring Rest API that helps manage the routing of the application.",
    functionalitiesPics: taxflow_screenshot,
    modelingPics: taxeflow_infrastructure,
    demoVideo: "",
    caseStudyBackground: taxflow_background,
    backgroundsAttribution: (
      <>
        Background photo by &nbsp;
        <a target="_blank" rel="noopener noreferrer" href="https://unsplash.com/@walkingondream?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">
          Olga DeLawrence
        </a>&nbsp;
        on&nbsp;
        <a target="_blank" rel="noopener noreferrer" href="https://unsplash.com/photos/5616whx5NdQ?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">
          Unsplash
        </a>
      </>
    )
  },
  {
    id: 2,
    name: "Pharmacy Desktop App",
    logo: potion_Logo,
    description: "Your comprehensive desktop solution for efficient pharmacy management. Streamline inventory, track prescriptions, manage patient records, and simplify billing all in one place.",
    previewImage: potion_preview,
    demo: "",
    gitRepo: "https://github.com/soulaimanedev/Potion-V1.git",
    viewCode: "pointer",
    imgAlt: "Potion project logo",
    projectInfoPath: "/project/potion",
    technologies: [
      "UML",
      "SQL Server",
      "Windows Forms",
      "C#",
      ".NET",
      "Entity Framework",
      "LINQ",
      "ADO.NET"
    ],
    projectDescription: "Potion is a desktop windows application made for the purpose of taking your pharmacy business to the next level with interesting and useful technologies",
    functionalities: "To manage a pharmacy business, the users needs to keep track of the whole aspects of a pharmacy so that's why it's built on CRUD operations(Create, Read, Update & delete) meaning the users can add new data depending on the entity or the class, get the data and display it, update the data's informations, and delete unwanted data.All of the functionalities are the following: CRUD for clients class, CRUD for medecin class, CRUD for pharmacist with the addition of a logging in using an encrypted password, CRUD for doctors, Create/Read for prescriptions, and an option to print the medecins data, using SAP CRYSTAL Reports",
    modeling: "The application consist of a total of five entities: Clients, Prescriptions, Medecin, Doctors, Receipts, Suppliers. If you see the code you'll notice that the namings are written in French which was the language that we use in our countrie's educational system. The diagrammes can be shown in the pictures o the left, which they explain the back-end's architecture and the relations between classes.",
    functionalitiesPics: potion_screenshot,
    modelingPics: potion_database_diagram,
    demoVideo: "https://www.youtube.com/embed/Z5PG7URJ0MA?list=PL2CRKbF8ZQvMOkQkOYB8HFklkNg-eDFO9",
    caseStudyBackground: potion_background,
    backgroundsAttribution: (
      <>
        Background photo by&nbsp;
        <a target="_blank" rel="noopener noreferrer" href="https://unsplash.com/@tbelabuseridze?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">
          Tbel Abuseridze
        </a>&nbsp;
        on&nbsp;
        <a target="_blank" rel="noopener noreferrer" href="https://unsplash.com/photos/eBW1nlFdZFw?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">
          Unsplash
        </a>
      </>
    )
  },
  {
    id: 3,
    name: "Javascript based pixels platform",
    logo: pixatopia_logo,
    description: "Unleash your creativity with the ultimate pixel art platform. Craft intricate designs one pixel at a time, harnessing a digital canvas that brings your imagination to life. Transform pixels into masterpieces, pixel by pixel.",
    previewImage: pixatopia_preview,
    demo: "",
    gitRepo: "https://github.com/soulaimanedev/Pixatopia.git",
    viewCode: "pointer",
    imgAlt: "Pixatopia project logo",
    projectInfoPath: "/project/pixatopia",
    technologies: ["HTML", "CSS", "JavaScript", "JQuery"],
    projectDescription: "A pixelated theme plateforme made for the purpose of bonding and being creative with other individuals accross the internet.",
    functionalities: "this project is about a new fun way to play with friends, express your ideas, your personality, the things you like, to discover new people and interests, all by participating in filling a grid of multiple pixels with images, links and colors, to make at the end one big artistic image of multiple pictures and colors.",
    modeling: "",
    functionalitiesPics: pixatopia_screenshot,
    modelingPics: "",
    demoVideo: "https://www.youtube.com/embed/yqArdR_2ynU",
    caseStudyBackground: pixatopia_background,
    backgroundsAttribution: (
      <>
        Background photo by&nbsp;
        <a target="_blank" rel="noopener noreferrer" href="https://unsplash.com/@pbernardon?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">
          Pascal Bernardon
        </a>&nbsp;
        on&nbsp;
        <a target="_blank" rel="noopener noreferrer" href="https://unsplash.com/photos/zWHZ_QsU4rc?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">
          Unsplash
        </a>
      </>
    )
  },
  {
    id: 4,
    name: "WindyTheory – CLI File Organizer",
    logo: windytheory_logo,
    description: "A menu-driven command-line tool that automates organizing and cleaning up files across your filesystem, with support for backup, undo, and history tracking.",
    previewImage: windytheory_logo,
    demo: "",
    gitRepo: "https://github.com/soulaimanedev/windy-theory.git",
    viewCode: "pointer",
    imgAlt: "WindyTheory project logo",
    projectInfoPath: "/project/windy-theory",
    technologies: ["Python", "SQLAlchemy", "SQLite", "pyinputplus"],
    projectDescription: "WindyTheory is a Python CLI application designed to take the hassle out of file management. It presents an interactive numbered menu that guides the user through common file operations — organizing files into categorized folders, cleaning up duplicates or junk, creating backups, undoing recent changes, and browsing operation history — all from the terminal without touching a GUI.",
    functionalities: "The tool offers seven operations accessible from a single menu: Organize (moves files into categorized directories), Cleanup (removes unwanted or duplicate files), Backup (creates a snapshot of a target directory), Undo (reverts the last operation), History (lists previous operations), Help (explains available commands), and Quit. The Organizer and Cleaner tasks are built as independent classes, keeping each feature self-contained and easy to extend.",
    modeling: "The project follows a modular architecture: Router handles menu presentation and delegates to the correct task class, individual task classes (Organizer, Cleaner) live under a tasks/ directory, shared utilities are split into managers/ and models/ packages. Local imports inside Router.suggest_tasks() are used deliberately to break circular import chains between the router and task modules.",
    functionalitiesPics: "",
    modelingPics: "",
    demoVideo: "",
    caseStudyBackground: windytheory_background,
    backgroundsAttribution: <></>
  },
  {
    id: 5,
    name: "Async Document OCR",
    logo: asyncdococr_logo,
    description: "An asynchronous PDF text extraction service built with FastAPI. Upload a document and poll for results — OCR runs in the background via RabbitMQ so the API never blocks.",
    previewImage: asyncdococr_logo,
    demo: "",
    gitRepo: "https://github.com/soulaimanedev/async-doc-ocr.git",
    viewCode: "pointer",
    imgAlt: "Async Document OCR project logo",
    projectInfoPath: "/project/async-doc-ocr",
    technologies: ["Python", "FastAPI", "PostgreSQL", "RabbitMQ", "Tesseract OCR", "Docker"],
    projectDescription: "async-doc-ocr is a production-style document processing service that decouples HTTP request handling from CPU-intensive OCR work. Clients upload a PDF, receive a job ID, and poll a status endpoint until the text is ready. A dedicated worker process consumes jobs from a RabbitMQ queue, runs Tesseract OCR via pdf2image and pytesseract, and writes the result back to PostgreSQL. The whole stack — API, worker, database, and message broker — is orchestrated with Docker Compose.",
    functionalities: "Key API capabilities: upload a PDF and receive a job ID, poll a status endpoint that returns pending / running / success / failed states, retrieve extracted text once the job completes, list all documents with limit/offset pagination. Failed OCR jobs are automatically retried up to three times via the Tenacity library before being marked as failed, ensuring transient errors don't silently drop documents.",
    modeling: "The service is split into two processes: the FastAPI HTTP server (async, non-blocking) and an OCR worker (consumes from RabbitMQ via aio-pika). PostgreSQL is accessed through asyncpg and SQLAlchemy's async ORM, keeping the entire data layer non-blocking. Docker Compose ties together four containers — api, worker, postgres, rabbitmq — making the full stack reproducible with a single command.",
    functionalitiesPics: "",
    modelingPics: "",
    demoVideo: "",
    caseStudyBackground: asyncdococr_background,
    backgroundsAttribution: <></>
  },
  {
    id: 6,
    name: "TBench – LLM Evaluation Framework",
    logo: tbench_logo,
    description: "A terminal-based framework for benchmarking LLM coding agents using mutation testing. Agents write pytest tests; the verifier scores quality by checking whether the tests detect deliberately injected bugs.",
    previewImage: tbench_logo,
    demo: "",
    gitRepo: "https://github.com/soulaimanedev/tbench.git",
    viewCode: "pointer",
    imgAlt: "TBench project logo",
    projectInfoPath: "/project/tbench",
    technologies: ["Python", "Pytest", "Docker", "Mutation Testing", "Harbor"],
    projectDescription: "TBench is a framework for running structured coding benchmarks against LLM agents. Each task ships with a Dockerfile that defines the agent's sandboxed environment, an instruction prompt, a reference solution (Oracle), and a verifier script that grades agent output objectively. The included pytest-quality task challenges agents to write comprehensive pytest tests for a Python module — quality is measured through mutation testing: the agent's tests must pass the correct implementation and also detect five deliberately injected bugs.",
    functionalities: "TBench workflow: (1) define a task with a Dockerfile environment, instruction, reference solution, and verifier; (2) run the Oracle to confirm the task is solvable; (3) run a target LLM agent against the task; (4) the verifier grades the output and assigns a reward of 0 or 1. The pytest-quality task includes five mutant versions of the source module, each with a different injected bug (e.g. word_count splitting on single space only, caesar_cipher treating shift=0 as shift=1), and the agent's tests must catch all five.",
    modeling: "Tasks follow a consistent directory layout: task.toml (Harbor config), instruction.md (agent prompt), environment/Dockerfile (sandbox), solution/solve.sh (Oracle), tests/test.sh (verifier). Results land in a timestamped jobs/ directory with full agent trajectories, verifier stdout, and a JSON result. The repo also includes a detailed failure analysis of GPT-4's run on the pytest-quality task, documenting LLM arithmetic unreliability and happy-path bias as root causes of test quality failures.",
    functionalitiesPics: "",
    modelingPics: "",
    demoVideo: "",
    caseStudyBackground: tbench_background,
    backgroundsAttribution: <></>
  }
];

export const projectsInfoMap = [0, 1, 2, 3, 4, 5, 6];
